// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qiSB","fullView":"styles_fullView__2tP_j"};